<span>
    <button type="button" mat-button *ngIf="!authenticated" (click)="login()" fxHide.xs fxHide.sm>Inloggen</button>
    <button type="button" mat-button *ngIf="authenticated" (click)="logout()">Uitloggen</button>
</span>
<span fxHide.xs fxHide.sm *ngIf="authenticated">{{name}}</span> 
<app-heart-beat></app-heart-beat>
<p-tieredMenu #menu [model]="items" [popup]="true"></p-tieredMenu>
<button #btn type="button" pButton icon="pi pi-bars" (click)="menu.toggle($event)" title="bars">{{lang}}</button>
